<avd-code-example-header
    [packageName]="packageName"
    [getStartedLink]="getStartedLink"
    [storybookLink]="storybookLink"
    [repoLink]="repoLink"
></avd-code-example-header>

@for (example of examples; track example.variant) {
    <avd-code-example
        [label]="example.label"
        [description]="example.description"
        [htmlSnippet]="example.htmlSnippet"
        [noPadding]="true"
    >
        <uilab-nav-rail
            [items]="example.items"
            [activeRoute]="example.activeRoute"
            [subMenuType]="'sidesheet'"
            [collapsed]="false"
        ></uilab-nav-rail>
    </avd-code-example>
}
